export default __webpack_public_path__ + "static/rush1-c63f990ad0dfa61c80d77372b06cdf65.png";